module.exports = __webpack_public_path__ + "img/activities-light.c474eed1.svg";